import { render, staticRenderFns } from "./MyPageList.vue?vue&type=template&id=32f228ce&scoped=true&"
import script from "./MyPageList.vue?vue&type=script&lang=js&"
export * from "./MyPageList.vue?vue&type=script&lang=js&"
import style0 from "./MyPageList.vue?vue&type=style&index=0&id=32f228ce&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32f228ce",
  null
  
)

export default component.exports